/** @module modules/teams/store/admin/state */

/**
 * @typedef {Object} TeamsAdminStoreState
 */
/**
 * @type {TeamsAdminStoreState}
 */
export default {}
